var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-color-black item1",staticStyle:{"width":"100%","height":"99.5%"}},[_c('tMap',{ref:"map",on:{"showAmInfo":_vm.showAmInfo}}),_c('amInfo',{ref:"amInfo",on:{"showLive":_vm.showLive}}),_c('dyLive',{ref:"liveDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }